import { useQueryGetStoreDetails } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'

export function useSnippetStore() {
  const { t } = useTranslation('saas', { keyPrefix: 'profile_store' })

  const { data: store } = useQueryGetStoreDetails()

  const snippetHeightManual = `
// ${t('section_iframe.iframe_height_manual_comment')}
<iframe
  width="100%"
  height="800"
  src="https://${store?.domain}.flecto.store/items"
></iframe>
`

  const snippetHeightAuto = `
// ${t('section_iframe.iframe_height_auto_comment_1')}
<script>
  window.addEventListener("message", function (event) {
    if (event.data.iframeHeight) {
      document.getElementById("store-iframe").style.height = event.data.iframeHeight + "px";
    }
  });
</script>

// ${t('section_iframe.iframe_height_auto_comment_2')}
<iframe
  id="store-iframe"
  src="https://${store?.domain}.flecto.store/items"
></iframe>
`

  return { snippetHeightAuto, snippetHeightManual }
}
